import { PropsWithChildren } from "react";
import { ChildrenOnlyProp } from "./commonProps";

export const Main: React.FC<PropsWithChildren<ChildrenOnlyProp & { className?: string }>> = ({
  children,
  className,
}) => {
  // IMPORTANT: No bottom padding or margin! The bond virtualized list must reach to the bottom of the page!
  return <main className={`grow flex flex-col overflow-x-hidden hide-scrollbar ${className}`}>{children}</main>;
};
